import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

export default function DiamondIcon(props) {
  return (
    <SvgIcon {...props} viewBox='0 0 21 21'>
      <g
        fill='none'
        fillRule='evenodd'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1'
      >
        <path d='m15.5 4l3 4l-8 10l-8-10l3.009-4zm-13 4h16m-11 0l3 10m3-10l-3 10' />
        <path d='M5.509 4L7.5 8l3-4l3 4l2-4' />
      </g>
    </SvgIcon>
  )
}
